// Require

const { id, log } = require("../std/index")

const KEY_ESCAPE = 27;

const keyMatch = (keycode, λ) => ({ which }) => which === 27 ? λ() : undefined;


//
// Navigation Controller
//

module.exports = class NavigationController {
  constructor($host, $$) {
    // Cache

    const $navicon = $$('.navicon.menu');
    const $slider = $$('.sliding-nav');
    const $slidingPane = $$('.sliding-pane');

    const slidingOpenClass = 'is-open';
    this.naviconActiveClass = 'is-active';


    // State

    const state = {
      navActive: $slider.hasClass(slidingOpenClass)
    };


    // Functions

    const toggleNav = () => {
      setNav(!state.navActive);
    };

    const dismissNav = () => {
      setNav(false);
    };

    const setNav = (mode) => {
      state.navActive = mode;
      $slider.toggleClass(slidingOpenClass, mode);
      $navicon.toggleClass(this.naviconActiveClass, mode);
    };

    const blockClicks = (event) => {
      event.stopPropagation();
    };


    // Listeners

    $navicon.on('click', toggleNav);
    $slider.on('click', dismissNav);
    $slidingPane.on('click', blockClicks);

    $(document).on('keydown', keyMatch(KEY_ESCAPE, dismissNav));


    // Init

    setNav(state.navActive);
  }
};
